import React from 'react';

import SimpleLoader from './SimpleLoader';

const FullLoader = () => {
    return (
        <SimpleLoader loaded={false}>
            <div>Loading...</div>
        </SimpleLoader>
    );
};

export default FullLoader;
